// src/config.js

// In Node (SSR), read from process.env; in the browser, read from import.meta.env
const env = typeof window === 'undefined' ? process.env : import.meta.env;

const isBrowser = typeof window !== 'undefined';
const hostname  = isBrowser ? window.location.hostname : '';
const origin    = isBrowser ? window.location.origin   : '';

const isTunnel = isBrowser && /(^|\.)crprojectstaging\.com$/i.test(hostname);
const isProd   = (env.NODE_ENV || env.MODE) === 'production';

// API base URL from env (Vite injects VITE_* variables into the frontend build)
const apiFromEnv = env.VITE_API_BASE_URL || env.API_BASE_URL;
const siteFromEnv = env.VITE_CLIENT_URL || env.CLIENT_URL;

// IMPORTANT: if running through a tunnel, force API/site URLs to the tunnel domains.
// In production, keep as is. Locally, use .env.development.
export const WEBSITE_URL = isTunnel
  ? origin // https://crprojectstaging.com
  : (siteFromEnv || '');

export const API_URL = isTunnel
  ? 'https://api.crprojectstaging.com'
  : (apiFromEnv || 'http://localhost:3001');

// everything else remains unchanged
export const COMPANY_NAME   = 'crino.io';
export const COMPANY_DOMAIN = 'crino.io';
export const CURRENT_YEAR   = new Date().getFullYear().toString();
export const CONTACT_EMAIL  = 'contact@crino.io';
export const CONTACT_PHONE  = '+380735621576';
export const COMPANY_ADDRESS= '49128, Metrobudivska 3, Dnipro city, Ukraine';
export const SOCIAL_X       = 'https://x.com/crino_io';
export const SOCIAL_FACEBOOK= 'https://facebook.com/';
export const SOCIAL_LINKEDIN= 'https://www.linkedin.com/company/crino-io/';
export const SOCIAL_WHATSAPP= 'https://wa.me/380735621576';
export const FREE_MEMBERSHIP= 'Free';
export const STARTUP_MEMBERSHIP = 'Startup';
export const PROFESSIONAL_MEMBERSHIP = 'Professional';
export const MEMBERSHIP_NAMES = {
  freeMembership: FREE_MEMBERSHIP,
  startupMembership: STARTUP_MEMBERSHIP,
  professionalMembership: PROFESSIONAL_MEMBERSHIP,
};

// Paddle
export const PADDLE_ENV = env.VITE_PADDLE_ENV || 'sandbox';
export const PADDLE_CONFIG = {
  sandbox: {
    environment: 'sandbox',
    token: env.VITE_PADDLE_SANDBOX_TOKEN || 'test_sandbox_token',
  },
  production: {
    environment: 'production',
    token: env.VITE_PADDLE_PRODUCTION_TOKEN || '',
  },
};
